<template>
  <div class="icon icon--arrow">
    <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 481.77 480.26">
      <path
        :style="iconStyle"
        d="M923.77,326.42l-29,23.41q-55.59,45-111.18,89.93a1.6,1.6,0,0,0-.71,2.05q28.26,90.49,56.45,181c.12.39.23.78.42,1.41l-1.55-1L696.87,525.75c-4.44-3.07-8.9-6.1-13.3-9.21a1.49,1.49,0,0,0-2.05,0q-48.62,33.55-97.25,67.07l-57.82,39.87-1.1.74c.5-1.87.91-3.45,1.33-5q24-88.76,48-177.49a1.61,1.61,0,0,0-.63-1.9q-56.89-48.6-113.76-97.25l-17.16-14.67c-.34-.28-.59-.72-1.11-.75v-1.5c.46,0,.91.07,1.37.07q85.67,0,171.33,0a1.74,1.74,0,0,0,2-1.36Q642.28,253.75,668,183.1q7.1-19.54,14.17-39.1h1a2.82,2.82,0,0,0,.41,1.55q32.82,89.37,65.62,178.77a1.89,1.89,0,0,0,2.15,1.45q85.47,0,170.95,0c.5,0,1-.05,1.5-.07v.75ZM682.44,403.6c.54,0,.61.52.83.83q53.47,74.91,106.94,149.83,13.38,18.74,26.72,37.47c.49.69.86,1.11,1.76.5.75-.5.27-1,.13-1.41q-5.09-15.93-10.21-31.86Q788.15,495.2,767.7,431.41a2.06,2.06,0,0,0-1.45-1.64q-41.19-12.93-82.35-25.92a2.83,2.83,0,0,0-1.46-.25,4.39,4.39,0,0,0,.15-1.61V181.06c0-.34,0-.68,0-1,0-.56-.24-.67-.74-.71-1.25-.13-1.14.92-1.37,1.57q-27,75.41-54,150.8a2.21,2.21,0,0,0,.43,2.45q27.31,34,54.58,68c.24.3.64.53.61,1a2.57,2.57,0,0,1-1.35-.29q-84.66-26.33-169.32-52.69c-11.09-3.46-22.18-6.9-33.25-10.41-1.27-.4-1.74.37-2.2,1.07s.46.93.84,1.24q55.65,46.37,111.33,92.72a2.46,2.46,0,0,0,2.77.49q40.53-14.15,81.08-28.2c3.46-1.2,6.86-2.56,10.4-3.49Zm.15,1c-.62.26-.79.72-1,1.07q-8.25,11.21-16.48,22.44-59.88,81.59-119.79,163.14c-1.26,1.7-1.75,3.07-.69,5,.71,1.29.56,1.38,1.8.5q67.44-47.64,134.89-95.28a2.71,2.71,0,0,0,1.34-2.52q-.06-46.35,0-92.7v-1.65Zm.28-1.46a2.21,2.21,0,0,0,1.5-.26q30.25-9.48,60.5-19l142.51-44.75c.72-.23,1.5-.34,1.28-1.44s-1-.55-1.52-.55l-149.77,0a2.53,2.53,0,0,0-2.23,1q-25.73,32-51.5,64c-.26.32-.5.66-.77,1Z"
        transform="translate(-442 -144)"/>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'icon-star',
    props: {
      color: {
        type: String,
        default: '#7fa8c1',
      },
    },
    computed: {
      iconStyle() {
        return {
          fill: this.color,
        };
      },
    },
  };
</script>
